import { faFlagAlt } from "@fortawesome/pro-regular-svg-icons";

import { ItemIcon } from "src/omnibox/ItemIcon";
import { OmniboxFeatureFlagLabel } from "src/omnibox/OmniboxFeatureFlagLabel";
import { FEATURE_FLAGS } from "src/router/featureFlags";

export const featureFlagBaseItems = Object.entries(FEATURE_FLAGS).map(
  ([key, value]) => ({
    label: <OmniboxFeatureFlagLabel featureFlag={value} />,
    icon: <ItemIcon bgColor="bg-gray-200" variant="default" icon={faFlagAlt} />,
    type: "Feature Flag",
    details: value,
    value: key,
  }),
);
